module.exports = __webpack_public_path__ + "static/media/PureSequence.0cd11a23.jpeg";